'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Button = require('../../Button/src/Button.js');
var Icon = require('../../Icon/src/Icon.js');
var Space = require('../../Space/src/Space.js');
var usePagination = require('../hooks/usePagination.js');
var Pagination_module = require('../styles/Pagination.module.less.js');
var PaginationButton = require('./PaginationButton.js');

const Pagination = (props) => {
    const { table, manualPagination } = props;
    const cx = reactUtils.useStyles(Pagination_module.default);
    const isMobile = reactUtils.useIsMobile();
    const rowCount = table.getRowCount();
    const innerPageSize = table.getState().pagination.pageSize;
    const innerPageCount = Math.ceil(rowCount / innerPageSize);
    const totalPageCount = manualPagination ? table.getPageCount() : innerPageCount;
    const currentPage = table.getState().pagination.pageIndex;
    const paginationRange = usePagination.usePagination(totalPageCount, currentPage, isMobile);
    if (paginationRange.length < 1) {
        return null;
    }
    return (React.createElement(Space.Space, { size: 12, justify: "flex-end" },
        table.getCanPreviousPage() && (React.createElement(Button.Button, { variant: "text", onClick: table.previousPage, className: cx('arrow') },
            React.createElement(Icon.Icon, { icon: React.createElement(reactIcons.ArrowLeft, null) }))),
        paginationRange.map((pageNumber) => (React.createElement(PaginationButton.PaginationButton, { key: pageNumber, pageNumber: pageNumber, currentPage: currentPage, onPageChanged: table.setPageIndex }))),
        table.getCanNextPage() && (React.createElement(Button.Button, { variant: "text", onClick: table.nextPage, className: cx('arrow') },
            React.createElement(Icon.Icon, { icon: React.createElement(reactIcons.ArrowRight, null) })))));
};

exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map
